<template>
    <div class="accommodations-banner">
         <navComponent :activeName="activeName"></navComponent>
        <div class="accommodations-banner-center banner-fade-in">
            <div class="accommodations-banner-content" ref="animate">
                <div class="title">activities</div>
                <div class="desc">On your tour,pick your daily activites based on your preferences</div>
                <div class="desc">and energy levels.</div>
            </div>
        </div>
    </div>
</template>
<script>
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default{
    components:{
        navComponent
    },
    data(){
        return {
            activeName:'third',
        }
    },
    mounted() {
        this.$nextTick(() => {
            const contentElement = this.$refs.animate;
            contentElement.classList.add('animate');
        })
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/activitiesBanner.scss';
.accommodations-banner{
    width: 100%;
    .accommodations-banner-center{
        height: 39.375rem;
        background: url('/static/img/banner/activitiesBanner.png') no-repeat center center;
        background-size: cover;
        background-position: top center;
        // min-width: 75rem;
        // max-width: 128rem;
        width: 100%;
        margin: 5.5rem auto 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .accommodations-banner-content{
            opacity: 0;
            transform: translateY(100%);
        }
        .title{
            margin-bottom: 1.875rem;
            color: #09080D;
            font-size: 4rem;
            font-weight: 700;
            line-height: 1.2;
            text-transform: capitalize;
            font-family: Butler;
            color: #fff;
        }
        .desc{
            color: #09080D;
            text-align: center;
            font-size: 1.25rem;
            font-weight: 300;
            font-family: Inter;
            color: #fff;
        }
    }
}
</style>